import api from './index';
//
let exports = {};

// 获取集团人员列表
exports.getRealStaffList = function (data, callback) {
    api.post('/real/authx/real/satff/list/get')
    .data(data)
    .done(callback)
    .go()
}

// 获取实体人员信息
exports.getRealSatffInfoByPhoneNo = function (postData, callback) {
    api.post('/real/authx/real/satff/info/get/by/phoneNo')
    .data(postData)
    .done(callback)
    .go();
};

// 获取人员角色中已分配该角色和正在交接中的集团人员的ids
exports.getStaffIds = function (params, callback) {
    api.get('/real/authx/staffIds/get')
    .params(params)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/realAuthx.js
// module id = 148
// module chunks = 1